import createAuth0Client from "@auth0/auth0-spa-js";
import axios from "axios";

export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

const AWS_FORM_SERVICE_BASE_URL =
  process.env.REACT_APP_AWS_FORM_SERVICE_BASE_URL;

let IdToken = null;

export const fetchAuth0IdToken = async () => {
  if (IdToken) {
    return IdToken;
  }

  const auth0FromHook = await createAuth0Client({
    domain: AUTH0_DOMAIN,
    client_id: AUTH0_CLIENT_ID,
  });

  // FIXME tokenClaims undefined error in congnito
  const tokenClaims = await auth0FromHook.getIdTokenClaims();
  IdToken = tokenClaims.__raw;

  return IdToken;
};

export const saveFormToDB = async (formData) => {
  const IdToken = await fetchAuth0IdToken();

  const config = {
    headers: { Authorization: `Bearer ${IdToken}` },
  };

  await axios.post(`${AWS_FORM_SERVICE_BASE_URL}/createForm`, formData, config);
};

export const getForms = async () => {
  const IdToken = await fetchAuth0IdToken();

  const config = {
    headers: { Authorization: `Bearer ${IdToken}` },
  };

  const { data } = await axios.get(
    `${AWS_FORM_SERVICE_BASE_URL}/getForms`,
    config
  );

  return data;
};

export const getForm = async (formId) => {
  const IdToken = await fetchAuth0IdToken();

  const config = {
    headers: { Authorization: `Bearer ${IdToken}` },
  };

  const { data } = await axios.get(
    `${AWS_FORM_SERVICE_BASE_URL}/getForm/${formId}`,
    config
  );

  return data;
};

export const submitResponse = async (formId, responseData) => {
  const IdToken = await fetchAuth0IdToken();

  const config = {
    headers: { Authorization: `Bearer ${IdToken}` },
  };

  await axios.post(
    `${AWS_FORM_SERVICE_BASE_URL}/submitResponse/${formId}`,
    responseData,
    config
  );
};

export const getResponses = async (formId) => {
  const IdToken = await fetchAuth0IdToken();

  const config = {
    headers: { Authorization: `Bearer ${IdToken}` },
  };

  const { data } = await axios.get(
    `${AWS_FORM_SERVICE_BASE_URL}/getResponses/${formId}`,
    config
  );

  return data;
};
